export class PartialBet {
  betType: string;
  ordered: boolean;
  arrBet: any[];

  constructor() {
    this.arrBet = [];
  }
}
